// Contributor photos are mirrored from the private S3 bucket into public/photos/
// by `npm run sync-photos`. The JSON files in src/data/ reference them with
// absolute paths like `/photos/{file}`. PHOTO_BASE is kept for any future
// code that wants to construct a URL from a raw filename.
export const PHOTO_BASE = "/photos/";
export const FLAG_BASE = "https://storage.googleapis.com/bilateral-navigator-images/originals/flags/";
// Primary geo source: same-origin Cloudflare Pages Function that reads
// request.cf (Maxmind-backed, no rate limit, no 3rd-party cost).
export const GEO_ENDPOINT = "/api/geo";
// Fallback only used when /api/geo returns no coords (e.g. `vite dev`
// on localhost, where Pages Functions are not active).
export const IPAPI_URL = "https://ipapi.co/json/";
export const CTA_TARGET = "#chief-row";
export const NYC_COORDS = { lat: 40.75, lon: -73.97 };
export const GLOBE_AUTOSPIN_DEG_PER_FRAME = 0.05;
export const GEO_TIMEOUT_MS = 2000;
